var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.916,
    height: 31.28,
    viewBox: "0 0 40.916 31.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H40.916V-31.28H0Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -13)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.219 -10.195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A.68.68,0,0,1-.68.677.679.679,0,0,1-1.359,0,.681.681,0,0,1-.68-.683.681.681,0,0,1,0,0",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.583 -14.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A7.33,7.33,0,0,0,0,14.66,7.339,7.339,0,0,0,7.333,7.33,7.339,7.339,0,0,0,0,0M-3.188,12.352A3.567,3.567,0,0,1,0,8.979a3.566,3.566,0,0,1,3.19,3.373A5.915,5.915,0,0,1,0,13.286a5.908,5.908,0,0,1-3.188-.934m7.6-1.032A4.892,4.892,0,0,0,0,7.605,4.889,4.889,0,0,0-4.406,11.32a5.922,5.922,0,0,1-1.55-3.99A5.965,5.965,0,0,1,0,1.374,5.964,5.964,0,0,1,5.959,7.33a5.925,5.925,0,0,1-1.547,3.99",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.329 -13.286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H-25.146V-14.156H3.568V-1.339c.229-.02.454-.035.686-.035s.463.015.688.035V-14.845a.687.687,0,0,0-.688-.686H-25.834a.687.687,0,0,0-.688.686V.688a.686.686,0,0,0,.688.686H-1.456A7.473,7.473,0,0,1,0,0",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.031 -3.765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H-2.479V-3.469h3.71a.934.934,0,0,1-.01-.1A7.335,7.335,0,0,1,1.342-4.84h-24.4a.6.6,0,0,1-.6-.6v-20.1a.6.6,0,0,1,.6-.595H10.075a.6.6,0,0,1,.6.595v14.965a7.421,7.421,0,0,1,1.374.574V-25.544a1.975,1.975,0,0,0-1.975-1.972H-23.06a1.974,1.974,0,0,0-1.971,1.972v20.1A1.971,1.971,0,0,0-23.06-3.469h12.554V0h-2.475a.688.688,0,0,0-.689.685V3.076a.688.688,0,0,0,.689.689H0a.688.688,0,0,0,.686-.689V.685A.687.687,0,0,0,0,0M-9.129-3.469h5.277V0H-9.129Zm8.441,5.86H-12.3V1.374H-.688Z",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.586 -5.687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A3.432,3.432,0,0,1-3.076-3.56,3.2,3.2,0,0,1,0-6.853,3.193,3.193,0,0,1,3.073-3.56,3.429,3.429,0,0,1,0,0M0-5.479A1.822,1.822,0,0,0-1.7-3.56c0,1.122.826,2.186,1.7,2.186S1.7-2.438,1.7-3.56A1.824,1.824,0,0,0,0-5.479",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.846 -25.046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0,0,0l0-.006A1.4,1.4,0,0,0-1.011-.443H-13.6a1.388,1.388,0,0,0-1,.431s0,0,0,.006S-14.613,0-14.613,0a1.4,1.4,0,0,0-.378.95V8.487a1.38,1.38,0,0,0,.354.923c.018.02.021.044.038.061a.74.74,0,0,0,.191.147,1.376,1.376,0,0,0,.805.26H-1.011a1.391,1.391,0,0,0,.873-.315s.006-.01.012-.01A1.381,1.381,0,0,0,.381,8.487V.952A1.387,1.387,0,0,0,0,0M-13.6,1.822l3.238,2.921-3.252,2.924Zm7.925,2.361a.5.5,0,0,0-.108.1L-7.307,5.648-8.824,4.28a1.366,1.366,0,0,0-.106-.1L-12.539.934-2.092.949ZM-9.337,5.666l1.57,1.415a.683.683,0,0,0,.46.179.674.674,0,0,0,.461-.179l1.573-1.415,3.155,2.839-10.357-.018Zm5.089-.923L-.993,1.81V7.667Z",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.133 -15.149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A.7.7,0,0,1-.486-.2a.686.686,0,0,1,0-.973,6.533,6.533,0,0,0,0-9.231.682.682,0,0,1,0-.97.681.681,0,0,1,.969,0A7.906,7.906,0,0,1,.483-.2.684.684,0,0,1,0,0",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.762 -17.121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A.688.688,0,0,1-.49-.2a.689.689,0,0,1,0-.97A3.7,3.7,0,0,0-.49-6.4a.692.692,0,0,1,0-.972.691.691,0,0,1,.973,0A5.074,5.074,0,0,1,.483-.2.677.677,0,0,1,0,0",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.945 -15.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A.682.682,0,0,1-.486-.2a7.91,7.91,0,0,1,0-11.171.686.686,0,0,1,.972,0,.687.687,0,0,1,0,.97,6.538,6.538,0,0,0,0,9.231.687.687,0,0,1,0,.97A.682.682,0,0,1,0,0",
    fill: "#ffae48"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.319 -17.153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0A.682.682,0,0,1-.486-.2a5.073,5.073,0,0,1,0-7.163.69.69,0,0,1,.972,0,.686.686,0,0,1,0,.973,3.7,3.7,0,0,0,0,5.22.677.677,0,0,1,0,.97A.665.665,0,0,1,0,0",
    fill: "#ffae48"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalAccount);
export default __webpack_public_path__ + "static/media/digital-account.1a44ba487dab5782717ea3fe42aecff5.svg";
export { ForwardRef as ReactComponent };